<!-- @format -->

<resign-confirm-tag>


  <div class="container_breadcrumb">
    <ul class="breadcrumb">
      <li class="breadcrumb-item"><a href="./" class="terms">退会手続き</a></li>
      <li class="breadcrumb-item"><h1>メール認証</h1></li>
    </ul>
  </div><!--/.container_breadcrumb-->
  
  <div class="contents">
    
    <section class="contents_area">
      <div class="contents_block detail">
        
        <p class="important_message important_message02 margin-spacing-4_bottom">登録されたメールアドレスに認証コードが記載されたメールを送信しました。<br>メールに記載された認証コードを入力してください。</p>
        
        
        
        <input class="text_input margin-spacing-4_top margin-spacing-1_bottom" type="text" name="code" id="code" placeholder="認証コード" onpaste= {(e)=>toggle(e)} onkeyup={(e)=>toggle(e)}>

        <div class="wrap_button margin-spacing-4_top margin-spacing-4_bottom">
          <button id="button" disabled class="button button-primary" type="button" value="{buttonName[state.option]}" onclick={(e)=>checkCode(e)}>{buttonName[state.option]}</button>
        </div><!--/.container_button-->
        
        <p class="note">※メールが届かない場合は、迷惑メールのフォルダやメールアドレスの入力を再度お試しください。</p>
        <p class="note">※認証コードは<strong>1時間有効</strong>です。時間を超過した場合はやり直してください。</p>
        <p class="note">※やり直した場合は有効時間内であっても、古い認証コードは無効となります。</p>
        
      </div><!--/.contents_block-->
    </section><!--/.contents_area-->
    
  </div><!--/.contents-->

<script>
  import di from "dependency-injection";
  export default {
    state: {
      checked: false,
      option: ''
    },
    buttonName: {
      'pausable': '退会予約・休止する',
      'unsubscribable': '退会する',
      '': ''
    },
    checkCode(e) {
      this.api.request('resign', 'check-code', {code: this.$('input#code').value})
        .then(data=>di.router.push('/menu/resign/complete#'+this.state.option))
        .catch(err => alert(err));
    },
    toggle(e) {
      if(e.type === "paste"){
        let my = this;
        setTimeout(function (){
          const target = $('button#button')[0];
          target.disabled = (e.target.value.length < 1);
        },1);
      }
      else{
        const target = $('button#button')[0];
        target.disabled = (e.target.value.length < 1);
      }
    },
    onBeforeMount(props, state) {
      this.api = di.createApi('menu');
      this.api.request('resign', 'fetch')
        .then(data=>this.update({option: data}));
    }
  }
</script>
</resign-confirm-tag>
